module.exports = __webpack_public_path__ + "officialStatic/img/productGw.e045cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productGw.png
// module id = HXbI
// module chunks = 0